__turbopack_context__.v({
  "checkbox": "RadioButtonIcon-module-scss-module__csnNOG__checkbox",
  "selected": "RadioButtonIcon-module-scss-module__csnNOG__selected",
});
